/* @fflow */

import React from 'react';
// $FlowIgnore
import { useDrop } from 'react-dnd';

let baseStyle = {
  border: '.3rem dashed #c9dce0',
};

const Dropzone = (props) => {
  let { accepts, children, style, onDrop } = props;
   const [dropProps, drop] = useDrop(() => ({
    accept: accepts,
    collect: (monitor) => {
      return {
        isOver: monitor.isOver()
      }
    },
    drop: (item) => {
      onDrop(item)
    },
  }));

  return (
      <div
      ref={drop}
      style={{
        ...baseStyle,
        ...style,
        backgroundColor: dropProps.isOver
          ? style[':hover'] || 'hsl(193, 64%, 94%)'
          : style.backgroundColor || 'hsl(193, 64%, 96%)'
      }}>
        {children}
      </div>
  );
}

export default Dropzone;